import { GRANT_TYPES, GRANT_TYPES_ID, TYPES, TYPES_ID } from './friends-referral-api.constants';
import { IGetRewardsResponseItem } from './friends-referral-api.types';

export const checkRewardEligible = (rewardItem: IGetRewardsResponseItem) => {
    /* we only want to display referrer/both and not the invitee reward */
    const isInviteeGrantType = rewardItem.grantType === GRANT_TYPES_ID[GRANT_TYPES.INVITEE];
    const isActive = rewardItem.active;
    const isTrialType = rewardItem.type === TYPES_ID[TYPES.TRIAL];
    const isRetentionType = rewardItem.type === TYPES_ID[TYPES.RETENTION];
    return !isInviteeGrantType && isActive && !isTrialType && !isRetentionType;
};
